/* global $ */

/*
Map of available tool base on material/process


/**
 *
 *
 */
(function (sculpteo) {
  "use strict";

  var TOOL_AVAILABLE_MAP = (sculpteo.TOOL_AVAILABLE_MAP = {});
  TOOL_AVAILABLE_MAP.ORIENTATION = new RegExp(
    /(nylon_pa12|pa11_sls|pa_12_hp|pa12_s|tpu|polypropylene|pa11_hp|pa11_esd|pa11_cf|fused_filament_fabrication|mjf_pa12_gb|mjf_pa12_fr|sls_pa12_gf)/
  ); // This list is made of part from the front_slug of MaterialOptionCombination (material name in the front_slug)
  TOOL_AVAILABLE_MAP.ORIENTATION_STAFF_ONLY = new RegExp(
    /(lcd_dlp|polyjet_resin|clip_resin|sla_resin|msla|vacuum_casting)/
  );
  TOOL_AVAILABLE_MAP.BATCH_CONTROL = new RegExp(/(nylon_pa12)/g);
  TOOL_AVAILABLE_MAP.HOLLOWING = new RegExp(
    /(nylon_pa12|pa11_sls|pa11_cf|pa11_esd|tpu|hp_plastic|pa11_hp|nylon|stainless_steel_420,rough,raw|stainless_steel_420,polished,raw|stainless_steel_316)/
  );
  TOOL_AVAILABLE_MAP.THICKENING = new RegExp(/\w+/);
  TOOL_AVAILABLE_MAP.ANNOTATIONS = new RegExp(/(nylon_pa12)/);
  TOOL_AVAILABLE_MAP.SLICER = new RegExp(/\w+/);
})((window.sculpteo = window.sculpteo || {}));
